const cartSl = {
	title: 'මගේ කර්ට්',
	clearAll: 'සියල්ල මකන්න',
	itemsInBag: (n) => `${n} භාණ්ඩ කර්ට් තුළ ඇත`,
	sectionCartItems: 'කර්ට් තුළ භාණ්ඩ',
	continueShopping: 'වෙළඳසැලට යන්න',
	orderSummary: 'ඇණවුම් සාරාංශය',
	subtotal: 'උප සමස්තය',
	delivery: 'බෙදාහැරීම',
	free: 'නොමිලේ',
	discount: 'වට්ටම',
	total: 'සම්පූර්ණය',
	couponPlaceholder: 'කූපන් කේතය ඇතුල් කරන්න',
	applyCoupon: 'කූපනය යොදන්න',
	proceedCheckout: 'ගෙවීම් වෙත යන්න',
	trust: {
		securePayment: '100% ආරක්ෂිත ගෙවීම්',
		fastDelivery: 'වේගවත් බෙදාහැරීම',
		cod: 'ලැබිලිදී ගෙවන්න'
	},
	empty: {
		title: 'ඔබගේ කර්ට් හිස්ය',
		subtitle: 'ඔබ තවම භාණ්ඩ කිසිවක් එකතු කර නොමැත.\nඅපගේ නිෂ්පාදන බලන්න සහ prārambha କරන්න!',
		cta: 'මිලදී ගැනීම prārambha କරන්න'
	},
	item: {
		inStock: 'තොග ඇත',
		removed: 'භාණ්ඩය කර්ට් න් ඉවත් කලා'
	},
	cleared: 'සියලු භාණ්ඩ ඉවත් කර ඇත'
};

export default cartSl;


